import { useQuery } from '@tanstack/react-query';
import { withBasePath } from '@/utils/withBasePath';
import type { OrganizerUserDataResponse } from '@/pages/api/organizers/[organizerId]/me.page';

async function fetchOrganizerUserData(organizerId: string): Promise<OrganizerUserDataResponse> {
  const res = await fetch(withBasePath(`/api/organizers/${organizerId}/me`), {
    credentials: 'include',
  });
  if (!res.ok) {
    return { userId: null, canManageProfile: false };
  }
  return (await res.json()) as OrganizerUserDataResponse;
}

export function useOrganizerUserData(organizerId: string | undefined) {
  const id = organizerId?.trim() ?? '';

  return useQuery({
    queryKey: ['organizer-user-data', id],
    queryFn: () => fetchOrganizerUserData(id),
    enabled: !!id,
  });
}
